// extracted by mini-css-extract-plugin
export default {"__":"errorPage_____D5FS7"};